import { zonoApi } from '../api/zonoApi';
import {
  CampaignDetailsRequest,
  CampaignDetailsResponse,
  CampaignDetailsV2Request,
  CampaignDetailsV2Response,
  CampaignProductsRequest,
  CampaignProductsResponse,
  CampaignsRequest,
  EachWabaTemplatesRes,
  TemplateListRequest,
  TemplateListResponse,
} from './campaign-model';

export const campaignApi = zonoApi.injectEndpoints({
  endpoints: (builder) => ({
    getCampaigns: builder.query<any, CampaignsRequest>({
      query: (args) => {
        return {
          url: `hub/commerce-v2/campaigns/${args?.workspaceId}`,
          params: args?.params,
          method: 'GET',
        };
      },
    }),
    getCampaignDetails: builder.query<
      CampaignDetailsResponse,
      CampaignDetailsRequest
    >({
      query: (args) => {
        return {
          url: `hub/commerce-v2/campaigns/${args?.workspaceId}/${args?.campaignId}`,
          params: args?.params,
          method: 'GET',
        };
      },
    }),
    getCampaignDetailsV2: builder.query<
      CampaignDetailsV2Response,
      CampaignDetailsV2Request
    >({
      query: (args) => {
        return {
          url: `hub/commerce-v2/campaigns/details/customer/${args?.workspaceId}`,
          params: args?.params,
          method: 'GET',
        };
      },
    }),
    getCampaignProducts: builder.mutation<
      CampaignProductsResponse,
      CampaignProductsRequest
    >({
      query({ workspaceId, sellerWorkspaceId, ...body }) {
        return {
          url: `/hub/commerce-v2/campaigns/products/${workspaceId}`,
          method: 'POST',
          params: { sellerWorkspaceId },
          body: body,
        };
      },
    }),
    templateList: builder.mutation<TemplateListResponse, TemplateListRequest>({
      query(arg) {
        const { sellerWorkSpaceId } = arg;
        return {
          url: `hub/orgs/api/templates/custom/list/${sellerWorkSpaceId}?sellerWorkspaceId=${sellerWorkSpaceId}`,
          body: arg,
          method: 'POST',
        };
      },
    }),
    getTemplateWithId: builder.query<EachWabaTemplatesRes, any>({
      query(arg) {
        const { sellerWorkspaceId, templateId } = arg;
        return {
          url: `hub/orgs/api/templates/custom/waba-template/${templateId}`,
          params: {
            sellerWorkspaceId: sellerWorkspaceId,
          },
          method: 'GET',
        };
      },
    }),
  }),
});

export const {
  useLazyGetCampaignsQuery,
  useLazyGetCampaignDetailsQuery,
  useLazyGetCampaignDetailsV2Query,
  useGetCampaignProductsMutation,
  useTemplateListMutation,
  useLazyGetTemplateWithIdQuery,
} = campaignApi;
